import { Sparkles } from "lucide-react";
import { useSiteSettings } from "@/contexts/SettingsContext";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Soft pre-launch banner shown at the top of every page when
 * settings.prelaunch_enabled is true. Lets visitors browse and host but
 * tells them bookings are not yet open.
 */
export default function PrelaunchBanner() {
  const { settings } = useSiteSettings();
  const { user } = useAuth();
  if (!settings?.prelaunch_enabled) return null;
  if (user?.role === "admin") return null; // admins can still book to test
  return (
    <div
      className="bg-amber-50 border-b border-amber-200 text-amber-900 text-xs sm:text-sm py-2 px-4 flex items-center justify-center gap-2"
      data-testid="prelaunch-banner"
    >
      <Sparkles className="h-3.5 w-3.5 flex-shrink-0" />
      <span className="text-center">
        <strong>Phase de pré-lancement</strong> — explorez, créez votre compte et publiez vos terrains.
        <span className="hidden sm:inline"> Les réservations ouvriront sous peu.</span>
      </span>
    </div>
  );
}
